/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  UpdateDesignTokensMutationRequest,
  UpdateDesignTokensMutationResponse,
  UpdateDesignTokensPathParams,
} from "../types/UpdateDesignTokens.ts"

export const updateDesignTokensMutationKey = () =>
  [
    {
      url: "/v1/organization-settings/update-design-tokens/:productSheetGroupId",
    },
  ] as const

export type UpdateDesignTokensMutationKey = ReturnType<
  typeof updateDesignTokensMutationKey
>

/**
 * @summary Update design tokens
 * {@link /v1/organization-settings/update-design-tokens/:productSheetGroupId}
 */
export async function updateDesignTokens(
  productSheetGroupId: UpdateDesignTokensPathParams["productSheetGroupId"],
  data?: UpdateDesignTokensMutationRequest,
  config: Partial<RequestConfig<UpdateDesignTokensMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateDesignTokensMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateDesignTokensMutationRequest
  >({
    method: "POST",
    url: `/v1/organization-settings/update-design-tokens/${productSheetGroupId}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateDesignTokensMutationOptions(
  config: Partial<RequestConfig<UpdateDesignTokensMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = updateDesignTokensMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateDesignTokensMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productSheetGroupId: UpdateDesignTokensPathParams["productSheetGroupId"]
      data?: UpdateDesignTokensMutationRequest
    },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ productSheetGroupId, data }) => {
      return updateDesignTokens(productSheetGroupId, data, config)
    },
  })
}

/**
 * @summary Update design tokens
 * {@link /v1/organization-settings/update-design-tokens/:productSheetGroupId}
 */
export function useUpdateDesignTokens<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateDesignTokensMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        productSheetGroupId: UpdateDesignTokensPathParams["productSheetGroupId"]
        data?: UpdateDesignTokensMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateDesignTokensMutationRequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateDesignTokensMutationKey()

  const baseOptions = updateDesignTokensMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateDesignTokensMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productSheetGroupId: UpdateDesignTokensPathParams["productSheetGroupId"]
      data?: UpdateDesignTokensMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateDesignTokensMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productSheetGroupId: UpdateDesignTokensPathParams["productSheetGroupId"]
      data?: UpdateDesignTokensMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateDesignTokensMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      productSheetGroupId: UpdateDesignTokensPathParams["productSheetGroupId"]
      data?: UpdateDesignTokensMutationRequest
    },
    TContext
  >
}
